import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TvShopStateService} from '../../../services/state/tv-shop-state.service';
import {Order} from '../../../model/order';
import {
  OrderingModalManagerComponent
} from '../../../modals/ordering-modals/ordering-modal-manager/ordering-modal-manager.component';
import {TvShopEntertainmentPack} from '../../../model/tv-shop-entertainment-pack';
import {NavigableComponent} from '../../../model/navigable-component';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {PageNames} from '../../../shared/page-names.enum';
import {AnalyticsService} from '../../../services/analytics/analytics.service';
import {StreamingOption} from '../../../model/sofy/sales-offer/option';
import {Basket} from '../../../interfaces/streaming-bundles/basket.interface';
import {Router} from '@angular/router';
import {ImageUtils} from '../../../shared/utils/image/image-utils';
import { ProductTypeRenditionEnum } from '../../../constants/renditions/product-type-rendition.constants';

@Component({
  selector: 'app-streaming-bundle-options',
  templateUrl: './streaming-bundle-options.component.html',
  styleUrls: ['./streaming-bundle-options.component.less']
})
export class StreamingBundleOptionsComponent extends NavigableComponent implements OnInit, AfterViewInit, OnDestroy {
  order: Order;
  omapiId: string;
  selectedTvShopEntertainmentPack: TvShopEntertainmentPack;
  availableStreamingBundleOption: StreamingOption;
  hasOptionSelected: boolean = false;

  componentName = PageNames.STREAMING_BUNDLE_OPTION;
  rendition: ProductTypeRenditionEnum = ProductTypeRenditionEnum.streamingBundle;

  @ViewChild('streamingbundleoption', {read: ElementRef})
  streamingbundleoption: ElementRef;

  @ViewChild('orderModal')
  private orderingModal: OrderingModalManagerComponent;

  constructor(
    protected navigationService: NavigationService,
    private changeDetector: ChangeDetectorRef,
    private analyticsService: AnalyticsService,
    private stateService: TvShopStateService,
    private router: Router
  ) {
    super(navigationService);
    this.selectedTvShopEntertainmentPack = stateService.selectSnapshot(state => state.basket.selectedTvShopEntertainmentPack);
    this.checkIfAlreadySubscribed();
    this.availableStreamingBundleOption = this.selectedTvShopEntertainmentPack.streamingOption[0];
    this.omapiId = this.selectedTvShopEntertainmentPack.omapiId;

    const streamingBundleBasket: Basket = this.stateService.selectSnapshot(state => state.basket);
    this.order = new Order(
      streamingBundleBasket.selectedTvShopEntertainmentPack.omapiId,
      streamingBundleBasket.selectedTvShopEntertainmentPack.priceDetail.price.value,
      null,
      null
    );
  }

  ngOnInit() {
    this.navigationService.setCurrentPageComponent(PageNames.STREAMING_BUNDLE_OPTION);
    this.analyticsService.onDetailPage([this.selectedTvShopEntertainmentPack.omapiId]);
  }

  ngAfterViewInit() {
    this.changeDetector.detectChanges();
    this.navigationService.registerPageElement(this.streamingbundleoption);
    this.navigationService.resetNavigation();

  }

  public get backgroundImageUrl(): string {
    return ImageUtils.getBackgroundImageUrl(this.selectedTvShopEntertainmentPack.omapiId, 'intro');
  }

  public get getLogoUrl(): string {
    return ImageUtils.getLogoUrlForOmapiId(this.omapiId);
  }

  ngOnDestroy() {
    this.navigationService.clearNavigation();
  }

  checkIfAlreadySubscribed() {
    if (this.selectedTvShopEntertainmentPack.subscribed) {
      this.onBack();
    }
  }

  onEmitOrderProduct() {
    this.orderingModal.openModal();
  }

  onBack() {
    this.navigationService.resetNavigation();
    this.navigationService.clearNavigation();
    this.routeOnBackPressed();
  }

  onToggleStreamingOption(streamingServiceOptionId: string) {
    const selectedStreamingServiceOption = this.stateService.selectSnapshot(state => state.basket.selectStreamingServiceOption);
    if (selectedStreamingServiceOption && (selectedStreamingServiceOption.omapiid === streamingServiceOptionId)) {
      this.hasOptionSelected = false;
      this.stateService.setSelectedStreamingBundleOption(undefined);
    } else {
      this.hasOptionSelected = true;
      this.stateService.setSelectedStreamingBundleOption(this.availableStreamingBundleOption);
    }
  }

  private routeOnBackPressed() {
    this.router.navigate(['/product-details/' + this.omapiId], {queryParamsHandling: 'merge'});
  }
}
